import { useContext, useState, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import { Outlet, useSearchParams } from "react-router-dom";
import NavBar from "../components/NavBar";
import NavBarExt from "../components/NavBarExt";
import axios from "axios";
import { ROOT_SERVER } from "./Static";
import { isLoggedInUserInfo } from "./AuthState";
//import SingleMaterial from "../pages/SingleMaterial";

function ExternalRoutes() {
  //const { vendor, slug } = useParams();
  const { userInformation } = useContext(UserContext);
  const isLoggedIn = isLoggedInUserInfo(userInformation);

  const [accessData, setAccessData] = useState([]);
  const [queryParameters] = useSearchParams();
  const access = queryParameters.get("access");

  const getAccess = async (access) => {
    const request = { accessId: access };
    try {
      const res = await axios.post(`${ROOT_SERVER}access`, request);
      setAccessData(res?.data?.[0] || []);
    } catch (error) {
      setAccessData([]);
    }
  };

  useEffect(() => {
    if (access) {
      getAccess(access);
    }
    //eslint-disable-next-line
  }, []);

  return isLoggedIn ? (
    <>
      <NavBar />
      <Outlet />
    </>
  ) : (
    <>
      <NavBarExt />
      <Outlet />
    </>
  );
}

export default ExternalRoutes;
